import { render, staticRenderFns } from "./sidebar_component.vue?vue&type=template&id=5fdd70e7&scoped=true"
import script from "./sidebar_component.vue?vue&type=script&lang=js"
export * from "./sidebar_component.vue?vue&type=script&lang=js"
import style0 from "./sidebar_component.vue?vue&type=style&index=0&id=5fdd70e7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdd70e7",
  null
  
)

export default component.exports